module.exports = __webpack_public_path__ + "img/default-profile.f33df0e9.png";